import acceptSound from "./apelo.mp3";

const accept = new Audio(acceptSound);
accept.volume = 0.3;

const sounds = {
  accept,
}

export default sounds;